<template>
  <div class="meWraper">
    <!--个人信息  -->
    <div class v-if="!isLoginOut">
      <div class="item">
        <span class="item_left">编辑头像</span>
        <div class="item_center">
          <img
            class="item_center_i"
            :src="userInfoData.photoPath?userInfoData.photoPath:require(`../../assets/images/img_default_face_${common.theme}.jpg`)"
          />
          <div class="item_center_inp" style="opacity:0;">
            <upload-img @uploadImg="uploadImg"></upload-img>
          </div>
        </div>
        <img class="item_right" src="./../../assets/images/me/right.png" />
      </div>
      <div class="item1">
        <span class="item_left1">真实姓名</span>
        <span class="item_center">{{common.userTenantInfo.userName || ''}}</span>
      </div>
      <div class="item1" @click="editName">
        <span class="item_left1">昵称</span>
        <span class="item_center">{{common.userInfo.userName}}</span>
        <img class="item_right" src="./../../assets/images/me/right.png" />
      </div>
      <div class="item1">
        <span class="item_left">性别</span>
        <div
          class="item_center"
          :class="{'item_center_2':gender=='','item_center_3':currentTags!=''}"
          @click="selectSex"
        >
          {{currentTags==''?'请选择性别':currentTags}}
          <img
            class="item_right"
            src="./../../assets/images/me/right.png"
          />
        </div>
      </div>
      <div class="item1">
        <span class="item_left1">生日</span>
        <div class="item_center" @click="selectFun">
          {{dateValue}}
          <img class="item_right" src="./../../assets/images/me/right.png" />
        </div>
      </div>
      <div class="item1">
        <span class="item_left1">手机号</span>
        <span class="item_center">{{phone}}</span>
      </div>
      <div class="item1" v-if="common.userTenanInfo && common.userTenanInfo.company">
        <span class="item_left1">公司</span>
        <span class="item_center">{{common.userTenanInfo.company}}</span>
      </div>
      <div class="item1" v-if="common.userTenanInfo && common.userTenanInfo.department">
        <span class="item_left1">部门</span>
        <span class="item_center">{{common.userTenanInfo.department}}</span>
      </div>
      <!-- <div class="item" @click="editUserInfo">
      <span class="item_left">更新会员资料</span>
      <div class="item_center"></div>
      <img class="item_right" src="./../../assets/images/me/right.png" />
      </div>-->
      <div class="item1 face_box" v-if="showRlSB" @click="toAddphone">
        <span class="item_left1">人脸识别</span>
        <span class="item_center">{{isshowAddPhone?'未录入':'重设人脸信息'}}</span>
        <img class="item_right" src="./../../assets/images/me/right.png" />
      </div>
    </div>
    <div class v-if="isLoginOut">
      <!-- <router-link tag="div" class="item1" to="/about">
      <span class="item_left1">关于</span>
      <span class="item_center"></span>
      <img class="item_right" src="./../../assets/images/me/right.png" />
      </router-link>-->
      <router-link tag="div" class="item1" to="/Service">
        <span class="item_left1">查看《服务协议》</span>
        <span class="item_center"></span>
        <img class="item_right" src="./../../assets/images/me/right.png" />
      </router-link>
      <router-link tag="div" class="item1" to="/agreeMent">
        <span class="item_left1">查看《隐私政策》</span>
        <span class="item_center"></span>
        <img class="item_right" src="./../../assets/images/me/right.png" />
      </router-link>
    </div>

    <yd-datetime
      v-if="!isLoginOut"
      style="display:none;"
      ref="datetime"
      @input="dateChange"
      type="date"
      placeholder="请选择日期"
      v-model="dateValue"
      start-date="1900-01-01"
    ></yd-datetime>

    <!-- // 此处slots为动态传入的值，通过computed来处理，数据通过vuex管理，由于数据为对象数组，需设置 value-key 属性来指定显示的字段名 -->
    <mt-popup v-if="!isLoginOut" v-model="popupVisible" position="bottom" class="mint-popup">
      <mt-picker
        class="picker"
        :slots="dataList"
        @change="onValuesChange"
        :visible-item-count="5"
        :show-toolbar="true"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>

    <mt-actionsheet
      :actions="actions"
      :cancelText="cancelText"
      :closeOnClickModal="true"
      v-model="sheetVisible"
    ></mt-actionsheet>
    <div class="btn" v-if="isLoginOut && common.userId" @click="toLogin">退出登录</div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { serversHttp, updateUserInfo, unbindingUser, uploadWapFile, getUserInfofaceImgUrl } from '../../utils/api';
import util from '../../utils/util.js';
import uploadImg from '../../components/uploadImg';
import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'me',
  components: {
    uploadImg
  },
  computed: {
    ...mapState({
      common: state => state.common,
      userInfoData: state => state.common.userInfo,
      marketInfo: state => state.common.marketInfo
    })
  },
  data() {
    return {
      isshowAddPhone: true,
      actions: [{
        name: '相册',
        method: this.selectPic
      }, {
        name: '拍照',
        method: this.takePhoto
      }],
      itemHeight: 100,
      sexList: [{
        flex: 1,
        values: ['男', '女'],
        className: 'slot1',
        textAlign: 'center'
      }],
      isLoginOut: false,
      dataList: [],
      dataTypeList: [1, 2],
      popupVisible: false,
      cancelText: '取消',
      sheetVisible: false,
      phone: '',
      imgUrl: '',
      imgId: '',
      userName: '',
      gender: '',
      modelType: '',
      firstdate: false,
      dateValue: '',
      currentTags: '',
      showRlSB: false,//显示人脸识别
    };
  },
  mounted() {
    this.userName = this.common.userInfo.realName || ''
    this.gender = this.common.userInfo.gender
    this.modelType = this.common.userInfo.modelType
    if (this.common.userInfo.birthday) {
      this.dateValue = util.formatTime(new Date(this.common.userInfo.birthday), 4)
    } else {
      this.dateValue = util.formatTime(new Date(), 4)
    }
    this.phone = this.common.userInfo.phone || this.common.userInfo.account;
    if (this.common.userInfo.gender == '1') {
      this.currentTags = '男'
    } else if (this.common.userInfo.gender == '2') {
      this.currentTags = '女'
    }
  },
  created() {
    let query = this.$route.query;
    var type = query.settingType;
    if (type == 1) {
      this.isLoginOut = true;
      document.title = "个人信息"
    } else {
      this.isLoginOut = false;
      document.title = "账户设置"
      this.getUserInfofaceImgUrl();
    }
  },
  methods: {
    ...mapActions(['getUserId', 'getUserInfo', 'getTenantInfo', 'getTenantInfoList']),
    selectSex() {
      this.popupVisible = true;
      this.dataList = this.sexList;
    },
    toAddphone() {
      this.$router.push({
        path: `/addPhoto?come=edit`
      });
    },
    getUserInfofaceImgUrl() {
      getUserInfofaceImgUrl({
        userId: this.common.userId,
        marketId: this.common.marketInfo.id,
      }).then(res => {
        console.log(res);
        if (res.res.code == 10000 && res.body) {
          this.showRlSB = true;
          if (res.body.faceImgUrl && res.body.faceImgUrl.length > 0) {
            this.isshowAddPhone = false;
          } else {
            this.isshowAddPhone = true;
          }
        } else {
          this.isshowAddPhone = true;
          this.showRlSB = false;
        }
      });
    },
    chooseImg() {
      let that = this;
      wx.ready(()=>{
        wx.chooseImage({
          count: 1, // 默认9
          sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
          success: function (res) {
            console.log(res)
            wx.uploadImage({
              localId: res.localIds[0],
              isShowProgressTips: 1,
              success: function (ret) {
                // 返回图片的服务器端ID
                util.showLoading('上传中...')
                var serverId = ret.serverId;
                that.uploadWapFile(serverId)
              }
            })
          }
        })
      })
    },
    uploadWapFile(id) {
      let params = {
        mediaId: id,
        marketId: this.common.marketInfo.id
      }
      uploadWapFile(params).then(res => {
        console.log(res)
        if (res.res.code === 10000) {
          this.imgId = res.body.imgId
          this.imgUrl = res.body.imgUrl
          this.updateUserInfo();
          util.hideLoading();
          util.showToast('上传成功')
          // this.$forceUpdate();
        } else {
          util.hideLoading();
          util.showToast('图片上传失败')
        }
      })
    },
    onValuesChange(picker, values) {
      if (values[0] > values[1]) {
        picker.setSlotValue(1, values[0]);
      }
    },
    handleConfirm() {
      this.popupVisible = false
      var valve = this.$refs.picker.getValues()[0];
      if (valve != this.currentTags) {
        this.currentTags = valve;

        if (this.currentTags == '男') {
          this.gender = '1';
        } else if (this.currentTags == '女') {
          this.gender = '2'
        }
        this.updateUserInfo()
      }
    },

    imgUpload(val) {
      console.log(val)
      let fd = new FormData();
      fd.append('file', val.target.files[0]); // 传文件
      fetch(serversHttp + 'servers.api/fileApi/uploadFile', {
        method: 'post',
        body: fd
      }).then(response => response.json()).then(res => {
        // util.showLoading('上传中...')
        console.log(res)
        if (res.res.code === 10000) {
          console.log(res.body.imgUrl)
          this.imgId = res.body.imgId
          this.imgUrl = res.body.imgUrl
          let userInfoData = this.common.userInfo;
          userInfoData.photoPath = this.imgUrl;
          this.getUserInfo({})
          this.getUserInfo(userInfoData)
          this.updateUserInfo();
        } else {
          util.showToast('图片上传失败')
          util.hideLoading()
        }
      })
    },
    uploadImg(val) {
      this.imgId = val.imgId
      this.imgUrl = val.imgUrl
      this.updateUserInfo()
    },
    selectFun() {
      this.$refs.datetime.open();
    },
    dateChange(val) {
      if (this.userInfoData.birthday != val) {
        var item = { val: this.userInfoData.birthday }
        var old1 = JSON.stringify(item)
        var old2 = JSON.parse(old1);
        this.userInfoData.birthday = val;
        this.dateValue = val;
        if (this.firstdate == false) {
          this.firstdate = true;
        } else {
          this.updateUserInfo(old2.val)
        }
      }
      if (this.firstdate == false) {
        this.firstdate = true;
      }
    },
    editName() {
      this.$router.push({
        path: '/me/editName'
      })
    },
    editUserInfo() {
      this.$router.push({
        path: '/me/editUserInfo'
      })
    },
    toLogin() {
      util.showModal('', '确定要退出登录吗?', true, '确定', () => {
        let header = {}
        if (this.common.cityId) {
          header.marketId = ''
        } else {
          header.cityId = ''
        }
        unbindingUser({}, header).then(res => {
          console.log(res)
          if (res && res.res && res.res.code == '10000') {
            this.getUserId('')
            this.getUserInfo({})
            this.getTenantInfo({})
            this.getTenantInfoList({})
            util.showToast('已退出')
            this.$router.go(-1)
            window.sessionStorage.removeItem("userData")
          }
        })
      }, () => {
      })
    },
    login() {
      if (!this.common.userId) {
        this.$router.replace({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          }
        })
      }
    },
    updateUserInfo(oldbirthday) {
      util.showLoading('跟新中...')
      let params = {
        userId: this.common.userId,
        modelType: this.userInfoData.modelType || '', // 1地铁 2公交 3自驾
        gender: this.gender || '',
        birthday: this.userInfoData.birthday || '',
        userName: this.userInfoData.userName || ''
      };
      if (this.imgId) {
        params.photoPath = this.imgId
      }
      updateUserInfo(params).then(res => {
        console.log(res)
        util.hideLoading()
        if (res.res.code === 10000) {
          let userInfoData = this.userInfoData;
          //this.common.userInfo;
          if (this.imgUrl) {
            userInfoData.photoPath = this.imgUrl;
          }
          userInfoData.gender = this.gender
          this.getUserInfo({})
          // console.log("userInfoData   ===   " + JSON.stringify(userInfoData))
          this.getUserInfo(userInfoData)
          // console.log("userInfo ===    " +JSON.stringify(this.common.userInfo))
        } else {
          if (oldbirthday) {
            this.userInfoData.birthday = oldbirthday;
            this.dateValue = oldbirthday;
          }
          util.showToast(res.res.msg, 2000);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.meWraper {
  width: 100%;
  background-color: #eee;
  flex: 1;
  overflow-x: hidden;
}
.item {
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 28px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.item_left {
  line-height: 120px;
  display: inline-block;
  font-size: 32px;
  text-align: left;
  color: #333333;
  //.fontSize(16px);
}

.item1 {
  height: 100px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 28px;
  box-sizing: border-box;
  background-color: #ffffff;
}
.face_box {
  margin-top: 14px;
}

.item_left1 {
  line-height: 100px;
  display: inline-block;
  font-size: 32px;
  text-align: left;
  color: #333333;
}
.item_center {
  flex: 1;
  height: 120px;
  .flex();
  justify-content: flex-end;
  align-items: center;
  color: #999999;
  font-size: 28px;
  line-height: 100px;
  text-align: right;
  padding-left: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  box-sizing: border-box;
  position: relative;
}
.item_center_i {
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}
.item_center_inp {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.item_right {
  width: 15px;
  height: 25px;
  margin: 3px 8px 3px 22px;
}
// btn
.btn {
  height: 100px;
  margin-top: 14px;
  line-height: 100px;
  text-align: center;
  //.fontSize(16px);
  font-size: 32px;
  color: #1740da;
  background-color: #ffffff;
}
.input {
  display: none;
}
</style>
